import { FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import { FleLinkWrapper } from "../../atoms/Links"
import React from "react"
import { TopSection } from "../TopSection"
import { DateOfBirthWithLabels } from "../../modal/BenefitEnrollmentFlow/ConnectInsuranceStep/DateOfBirthWithLabels"

const AboutYouDateOfBirth = ({ dateOfBirth, validDateOfBirth, dateOfBirthRef, onComplete }) => {
  return (
    <FleLayout>
      <TopSection progressStep={2} leftOrBackArrow={<BackArrow />} />
      <SwitchH2ToBodyLarge>When were you born?</SwitchH2ToBodyLarge>
      <Spacer height={3} />
      <DateOfBirthWithLabels
        dateOfBirth={dateOfBirth}
        dateOfBirthRef={dateOfBirthRef}
        validDateOfBirth={validDateOfBirth}
      />
      <FleLinkWrapper>
        <ContinueArrow onClick={onComplete} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { AboutYouDateOfBirth }
